import {useEffect} from 'react'
import {useParams, useSearchParams} from 'react-router-dom'

import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useFetch from 'shared/model/useFetch'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetExamVersionList = () => {
	const [searchParams] = useSearchParams()
	const page = searchParams.get('page')
	const proGrade = searchParams.get('proGrade')
	const {idx} = useParams()

	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [, setAlert] = useAlertModalAtom()
	const [userRole] = useRoleCookie()
	useEffect(() => {
		const rolePath = getApiRolePath(userRole)
		fetchRequest(
			'GET',
			`/${rolePath}/exam/list?page=${page}&type=${proGrade}&manager_idx=${idx}`
		)
	}, [page, proGrade])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				if (fetchResult?.data?.error_code === 'page')
					setAlert('페이지 번호 입력 양식을 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'type')
					setAlert('시험 종류 입력 양식을 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
		}
	}, [fetchResult])

	return [fetchResult, isLoading]
}

export default useGetExamVersionList
